import { useTableCellContext } from 'components/Table/TableCell/context';
import { useTableModalContext } from 'components/Table/context';
import { useEllipsisTooltipForTableCells } from 'hooks/useEllipsisTooltipForTableCells';
import { Box, useTheme } from '@chakra-ui/react';
import TableCellMultipleValuesModalContent from './TableCellMultipleValuesModalContent';

const TableCellMultipleValues = () => {
  const theme = useTheme();

  const cellContext = useTableCellContext();
  if (cellContext.cellType === 'multipleValues') {
    const {
      title,
      borderRadius,
      multipleValuesHeight,
      multipleValuesMinHeight,
      margin,
      textFontFamily,
      textFontSize,
      textLineHeight,
      textFontWeight,
      textColor,
      textTextAlign,
      moreNumberFontFamily,
      moreNumberFontSize,
      moreNumberLineHeight,
      moreNumberFontWeight,
      moreNumberColor,
      moreNumberTextAlign,
      handleClick,
      dataTestId,
      multipleValuesJustifyContent,
      multipleValuesAlignItems
    } = cellContext;

    const { setTableModalContent, setIsTableModalOpen } =
      useTableModalContext();

    const [cellMultipleValuesRef, overflowActive] =
      useEllipsisTooltipForTableCells();

    const handleCellClick = () => {
      if (overflowActive) {
        const text = Array.isArray(title) ? title[0] : title;
        setTableModalContent(
          <TableCellMultipleValuesModalContent fullText={text} />
        );
        setIsTableModalOpen(true);
      }
    };

    return (
      <Box
        display='flex'
        alignItems={multipleValuesAlignItems || 'center'}
        justifyContent={multipleValuesJustifyContent || 'space-between'}
        height={multipleValuesHeight || '28px'}
        minHeight={multipleValuesMinHeight || '28px'}
        margin={margin || 0}
        border-radius={borderRadius || 0}
        borderRadius={borderRadius}
        data-testid={dataTestId || 'cjtable-multiple-values-cell-id'}
      >
        <Box
          color={textColor || theme.colors.mediumGrey}
          fontFamily={textFontFamily || theme.fonts.regular}
          fontSize={textFontSize || '12px'}
          fontWeight={textFontWeight || 'normal'}
          textAlign={textTextAlign || 'left'}
          cursor={overflowActive ? 'pointer' : 'auto'}
          lineHeight={textLineHeight || '12px'}
          overflow='hidden'
          textOverflow='ellipsis'
          display='-webkit-box'
          sx={{
            WebkitBoxOrient: 'vertical',
            WebkitLineClamp: '2'
          }}
          ref={cellMultipleValuesRef}
          data-testid='cjtable-multiple-values-cell-text'
          onClick={handleCellClick}
        >
          {title && title[0]}
        </Box>
        {title && title.length > 1 && (
          <Box
            color={moreNumberColor || theme.colors?.greenMedium}
            fontFamily={moreNumberFontFamily || theme.fonts.semiBold}
            fontSize={moreNumberFontSize || '12px'}
            fontWeight={moreNumberFontWeight || '600'}
            textAlign={moreNumberTextAlign || 'right'}
            paddingLeft='5px'
            cursor='pointer'
            data-testid='cjtable-multiple-values-cell-moreNumber'
            lineHeight={moreNumberLineHeight}
            onClick={handleClick}
          >
            +{title.length - 1}
          </Box>
        )}
      </Box>
    );
  }
  return null;
};

export default TableCellMultipleValues;
